/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListLegacyProductsQueryResponse,
  ListLegacyProductsQueryParams,
  ListLegacyProducts400,
} from '../types/ListLegacyProducts'

function getListLegacyProductsUrl() {
  const res = { method: 'GET', url: `/api/v1/products/` as const }
  return res
}

/**
 * @summary List products (legacy endpoint, paginated)
 * {@link /api/v1/products/}
 */
export async function listLegacyProducts(
  params?: ListLegacyProductsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListLegacyProductsQueryResponse,
    ResponseErrorConfig<ListLegacyProducts400>,
    unknown
  >({
    method: 'GET',
    url: getListLegacyProductsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
